import React from "react";

export const IndustrialSites = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Shell Pernis biobrandstoffen - werken aan een duurzamere toekomst
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/industrial-sites-success-stories-pernis.jpg">
        <source
          src="videos/Shell Pernis biobrandstoffen- werken aan een duurzamere toekomst.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
        <img src="images/_qrCode.jpg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Hoe douchen we in de toekomst?</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Hoe douchen we in de toekomst.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
        <img src="images/qr/qr-industrial-sites-success-story-video-02.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Shell gebruikt plastic afval als grondstof voor chemicaliën
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/industrial-sites-success-stories-chemicalien.jpg">
        <source
          src="videos/Shell gebruikt plastic afval als grondstof voor chemicalien.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-industrial-sites-success-story-video-03.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Hallo Holland Hydrogen 1 | Europe’s largest hydrogen plant
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/industrial-sites-success-stories-holland-hydrogen.jpg">
        <source
          src="videos/Hallo Holland Hydrogen 1 Europe’s largest hydrogen plant.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-industrial-sites-success-story-video-04.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
  <h4 className="slideTitle">Het circulaire proces van het recyclen van kunststofafval</h4>
    <div class="video_container">
      <video width="320" height="240" controls poster="videos/industrial-sites-success-stories-circulaire-proces.jpg">
        <source
          src="videos/Het circulaire proces van het recyclen van kunststofafval.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-industrial-sites-success-story-video-05.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
];
